export default __webpack_public_path__ + "static/media/vi_leer2.9c413121.mp4";